import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toPersianNum } from "../../../utils/persianNumbers";
import { getTransactionsHistory } from "../../../services/bank";
import { getCommoditiesList } from "../../../services/commodities";

export default function HistoryOrder() {
  const navigate = useNavigate();
  const [ordersbuy, setOrdersBuy] = useState([]);
  const [orderssell, setOrdersSell] = useState([]);
  const [isLoading, setLoading] = useState(true);
  const [FailOrders, setFailOrders] = useState([]);
  const [commodities, setCommodities] = useState([]);
  const [page, setPage] = useState(1);
  const [dataType, setDataType] = useState(6);
  const [hasNext, setHasNext] = useState();

  const [active, setActive] = useState("buy");

  useEffect(() => {
    function fetchData() {
      setLoading(true);
      if (dataType > 0) {
        getCommoditiesList().then((data) => {
          setCommodities(data.data.results);
          getTransactionsHistory(page, dataType).then((res) => {
            setLoading(false);
            if (res.status == 200) {
              const data = res?.data?.results || [];
              setHasNext(res?.data?.next);
              if (dataType === 6) {
                setOrdersBuy([...ordersbuy, ...res?.data?.results]);
              }
              if (dataType === 7) {
                setOrdersSell([...orderssell, ...res?.data?.results]);
              }
              if (dataType === 8) {
                setFailOrders([...FailOrders, ...res?.data?.results]);
              }
            }
          });
        });
      }
    }
    fetchData();
  }, [page, dataType]);

  return (
    <>
      <div className="khfaygafbajfafa">
        <div>
          <div className="history-trade-tabs">
            <div
              className={
                active == "buy"
                  ? "form-input-button-custom"
                  : "form-input-button-custom not-active-login"
              }
              onClick={() => {
                setPage(1);
                setActive("buy");
                setDataType(6);
                setOrdersBuy([]);
              }}
            >
              خرید
            </div>
            <div
              className={
                active == "sell"
                  ? "form-input-button-custom"
                  : "form-input-button-custom not-active-login"
              }
              onClick={() => {
                setActive("sell");
                setPage(1);
                setDataType(7);
                setOrdersSell([]);
              }}
            >
              فروش
            </div>
            <div
              className={
                active == "failed"
                  ? "form-input-button-custom"
                  : "form-input-button-custom not-active-login"
              }
              onClick={() => {
                setActive("failed");
                setPage(1);
                setDataType(8);
                setFailOrders([]);
              }}
            >
              ناموفق
            </div>
          </div>
        </div>

        {ordersbuy || orderssell ? (
          <>
            <div className="list-of-items-history">
              {active == "buy" ? (
                Array.isArray(ordersbuy) && ordersbuy.length > 0 ? (
                  ordersbuy.map((li) => (
                    <div className="wrapper-for-history-account">
                      <div
                        className="history-account-item"
                        style={{
                          backgroundColor: commodities.find(
                            (el) => li["commodity"]["id"] == el.id
                          )?.ui_data?.colors?.primary,
                        }}
                      >
                        <span className="history-top-row-items">
                          <div>
                            <img
                              width={15}
                              className="icon-sandogh"
                              src={
                                commodities.find(
                                  (el) => li["commodity"]["id"] == el.id
                                )?.ui_data?.icons?.primary
                              }
                            />
                            {toPersianNum(li["commodity"]["name"])} :{" "}
                            {new Intl.NumberFormat("fa").format(
                              Math.abs(Math.abs(li["gold_amount"]))
                            )}{" "}
                            {" گرم"}
                          </div>
                          <div>
                            <span>
                              {toPersianNum(li["created_at"].split("T")[0])}
                            </span>
                          </div>
                        </span>
                        <div className="history-top-row-items">
                          <div className="trade-history-bottom-row">
                            {new Intl.NumberFormat("fa").format(
                              Math.abs(Math.abs(li["cash_amount"]))
                            )}
                            {" تومان"}
                          </div>
                          <div className="trade-history-bottom-row">
                            <span
                              className={
                                li?.profit?.percentage < 0
                                  ? "trade-red-color"
                                  : "trade-green-color"
                              }
                            >
                              {"%"}
                              {isNaN(li?.profit?.percentage)
                                ? new Intl.NumberFormat("fa").format(0)
                                : new Intl.NumberFormat("fa").format(
                                    li?.profit?.percentage
                                  )}
                              <span className="chart-icon-account-history">
                                {li?.profit?.percentage > 0 ? (
                                  <svg
                                    width="13"
                                    height="13"
                                    viewBox="0 0 20 17"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M19.5 15.75C19.5 15.9489 19.421 16.1397 19.2803 16.2803C19.1397 16.421 18.9489 16.5 18.75 16.5H0.75C0.551088 16.5 0.360322 16.421 0.21967 16.2803C0.0790176 16.1397 0 15.9489 0 15.75V0.75C0 0.551088 0.0790176 0.360322 0.21967 0.21967C0.360322 0.0790178 0.551088 0 0.75 0C0.948912 0 1.13968 0.0790178 1.28033 0.21967C1.42098 0.360322 1.5 0.551088 1.5 0.75V10.9397L6.21937 6.21937C6.28903 6.14964 6.37175 6.09432 6.46279 6.05658C6.55384 6.01884 6.65144 5.99941 6.75 5.99941C6.84856 5.99941 6.94616 6.01884 7.03721 6.05658C7.12825 6.09432 7.21097 6.14964 7.28063 6.21937L9.75 8.68969L14.6897 3.75H12.75C12.5511 3.75 12.3603 3.67098 12.2197 3.53033C12.079 3.38968 12 3.19891 12 3C12 2.80109 12.079 2.61032 12.2197 2.46967C12.3603 2.32902 12.5511 2.25 12.75 2.25H16.5C16.6989 2.25 16.8897 2.32902 17.0303 2.46967C17.171 2.61032 17.25 2.80109 17.25 3V6.75C17.25 6.94891 17.171 7.13968 17.0303 7.28033C16.8897 7.42098 16.6989 7.5 16.5 7.5C16.3011 7.5 16.1103 7.42098 15.9697 7.28033C15.829 7.13968 15.75 6.94891 15.75 6.75V4.81031L10.2806 10.2806C10.211 10.3504 10.1283 10.4057 10.0372 10.4434C9.94616 10.4812 9.84856 10.5006 9.75 10.5006C9.65144 10.5006 9.55384 10.4812 9.4628 10.4434C9.37175 10.4057 9.28903 10.3504 9.21937 10.2806L6.75 7.81031L1.5 13.0603V15H18.75C18.9489 15 19.1397 15.079 19.2803 15.2197C19.421 15.3603 19.5 15.5511 19.5 15.75Z"
                                      fill="#2BBD1E"
                                    />
                                  </svg>
                                ) : !isNaN(li?.profit?.percentage) ? (
                                  <svg
                                    width="13"
                                    height="13"
                                    viewBox="0 0 20 17"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M19.5 15.75C19.5 15.9489 19.421 16.1397 19.2803 16.2803C19.1397 16.421 18.9489 16.5 18.75 16.5H0.75C0.551088 16.5 0.360322 16.421 0.21967 16.2803C0.0790176 16.1397 0 15.9489 0 15.75V0.75C0 0.551088 0.0790176 0.360322 0.21967 0.21967C0.360322 0.0790178 0.551088 0 0.75 0C0.948912 0 1.13968 0.0790178 1.28033 0.21967C1.42098 0.360322 1.5 0.551088 1.5 0.75V1.93969L6.75 7.18969L9.21937 4.71937C9.28903 4.64964 9.37175 4.59432 9.4628 4.55658C9.55384 4.51884 9.65144 4.49941 9.75 4.49941C9.84856 4.49941 9.94616 4.51884 10.0372 4.55658C10.1283 4.59432 10.211 4.64964 10.2806 4.71937L15.75 10.1897V8.25C15.75 8.05109 15.829 7.86032 15.9697 7.71967C16.1103 7.57902 16.3011 7.5 16.5 7.5C16.6989 7.5 16.8897 7.57902 17.0303 7.71967C17.171 7.86032 17.25 8.05109 17.25 8.25V12C17.2514 12.025 17.2514 12.05 17.25 12.075C17.25 12.0853 17.25 12.0947 17.2453 12.105C17.2406 12.1153 17.2453 12.1331 17.2388 12.1481C17.2367 12.1599 17.2339 12.1715 17.2303 12.1828C17.2303 12.195 17.2247 12.2072 17.2209 12.2194C17.2172 12.2316 17.2134 12.2409 17.2097 12.2522L17.1966 12.2887L17.1825 12.3178C17.1769 12.33 17.1712 12.3431 17.1647 12.3553C17.1581 12.3675 17.1544 12.3722 17.1497 12.3816L17.1272 12.4181L17.1075 12.4444L17.0831 12.4772C17.0728 12.4903 17.0606 12.5025 17.0494 12.5147L17.0344 12.5316L17.0184 12.5456C17.006 12.5579 16.9928 12.5695 16.9791 12.5803C16.9695 12.5886 16.9595 12.5965 16.9491 12.6038L16.9209 12.6244L16.8853 12.6459C16.8763 12.6518 16.8669 12.6571 16.8572 12.6619L16.8225 12.6797L16.7906 12.6937L16.7569 12.7059C16.7453 12.7108 16.7334 12.7149 16.7213 12.7181L16.6875 12.7275C16.6744 12.7275 16.6631 12.7341 16.65 12.7359L16.6106 12.7425L16.5778 12.7472C16.5531 12.7486 16.5284 12.7486 16.5037 12.7472H12.75C12.5511 12.7472 12.3603 12.6682 12.2197 12.5275C12.079 12.3869 12 12.1961 12 11.9972C12 11.7983 12.079 11.6075 12.2197 11.4669C12.3603 11.3262 12.5511 11.2472 12.75 11.2472H14.6897L9.75 6.31031L7.28063 8.78063C7.21097 8.85036 7.12825 8.90568 7.03721 8.94342C6.94616 8.98116 6.84856 9.00059 6.75 9.00059C6.65144 9.00059 6.55384 8.98116 6.46279 8.94342C6.37175 8.90568 6.28903 8.85036 6.21937 8.78063L1.5 4.06031V15H18.75C18.9489 15 19.1397 15.079 19.2803 15.2197C19.421 15.3603 19.5 15.5511 19.5 15.75Z"
                                      fill="#FF0000"
                                    />
                                  </svg>
                                ) : (
                                  <></>
                                )}
                              </span>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  !isLoading && (
                    <div className="no-history-item">
                      <img src={"/images/account-no-history.png"} alt={""} />
                      <div className="no-history-item-title">
                        هنوز معامله نکرده‌اید؟
                        <span>وقت طلاست!</span>
                      </div>
                      <div className="no-history-item-subtitle">
                        همین حالا در طلایی‌شو بخرید، بفروشید و سود کنید.
                      </div>
                      <div className="trade-on-no-histoy">
                        <button
                          className="form-input-button-custom"
                          onClick={() => navigate("/trade-market")}
                        >
                          با بودجه کم معامله کنید
                        </button>
                      </div>
                    </div>
                  )
                )
              ) : (
                <></>
              )}
              {active == "sell" ? (
                Array.isArray(orderssell) && orderssell.length > 0 ? (
                  orderssell.map((li) => (
                    <div className="wrapper-for-history-account">
                      <div
                        className="history-account-item"
                        style={{
                          backgroundColor: commodities.find(
                            (el) => li["commodity"]["id"] == el.id
                          )?.ui_data?.colors?.primary,
                        }}
                      >
                        <span className="history-top-row-items">
                          <div>
                            <img
                              width={15}
                              className="icon-sandogh"
                              src={
                                commodities.find(
                                  (el) => li["commodity"]["id"] == el.id
                                )?.ui_data?.icons?.primary
                              }
                            />
                            {toPersianNum(li["commodity"]["name"])} :{" "}
                            {new Intl.NumberFormat("fa").format(
                              Math.abs(Math.abs(li["gold_amount"]))
                            )}{" "}
                            {" گرم"}
                          </div>
                          <div>
                            <span>
                              {toPersianNum(li["created_at"].split("T")[0])}
                            </span>
                          </div>
                        </span>
                        <div className="history-top-row-items">
                          <div className="trade-history-bottom-row">
                            {new Intl.NumberFormat("fa").format(
                              Math.abs(Math.abs(li["cash_amount"]))
                            )}
                            {" تومان"}
                          </div>
                          <div className="trade-history-bottom-row"></div>
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  !isLoading && (
                    <div className="no-history-item">
                      <img src={"/images/account-no-history.png"} alt={""} />
                      <div className="no-history-item-title">
                        هنوز معامله نکرده‌اید؟
                        <span>وقت طلاست!</span>
                      </div>
                      <div className="no-history-item-subtitle">
                        همین حالا در طلایی‌شو بخرید، بفروشید و سود کنید.
                      </div>
                      <div className="trade-on-no-histoy">
                        <button
                          className="form-input-button-custom"
                          onClick={() => navigate("/trade-market")}
                        >
                          با بودجه کم معامله کنید
                        </button>
                      </div>
                    </div>
                  )
                )
              ) : (
                <></>
              )}
              {active == "failed" ? (
                Array.isArray(FailOrders) && FailOrders.length > 0 ? (
                  FailOrders.map((li) => (
                    <div className="wrapper-for-history-account">
                      <div
                        className="history-account-item"
                        style={{
                          backgroundColor: commodities.find(
                            (el) => li["commodity"]["id"] == el.id
                          )?.ui_data?.colors?.primary,
                        }}
                      >
                        <span className="history-top-row-items">
                          <div>
                            <img
                              width={15}
                              className="icon-sandogh"
                              src={
                                commodities.find(
                                  (el) => li["commodity"]["id"] == el.id
                                )?.ui_data?.icons?.primary
                              }
                            />
                            {toPersianNum(li["commodity"]["name"])} :{" "}
                            {new Intl.NumberFormat("fa").format(
                              Math.abs(Math.abs(li["gold_amount"]))
                            )}{" "}
                            {" گرم"}
                          </div>
                          <div>
                            <span>
                              {toPersianNum(li["created_at"].split("T")[0])}
                            </span>
                          </div>
                        </span>
                        <div className="history-bottom-row-items">
                          <span>
                            {new Intl.NumberFormat("fa").format(
                              Math.abs(li["cash_amount"])
                            )}{" "}
                            {" تومان "}
                          </span>
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  !isLoading && (
                    <div className="no-history-item">
                      <img src={"/images/account-no-history.png"} alt={""} />
                      <div className="no-history-item-title">
                        هنوز معامله نکرده‌اید؟
                        <span>وقت طلاست!</span>
                      </div>
                      <div className="no-history-item-subtitle">
                        همین حالا در طلایی‌شو بخرید، بفروشید و سود کنید.
                      </div>
                      <div className="trade-on-no-histoy">
                        <button
                          className="form-input-button-custom"
                          onClick={() => navigate("/trade-market")}
                        >
                          با بودجه کم معامله کنید
                        </button>
                      </div>
                    </div>
                  )
                )
              ) : (
                <></>
              )}
            </div>
            {hasNext &&
            ((active === "buy" && ordersbuy.length > 0) ||
              (active === "sell" && orderssell.length > 0) ||
              (active === "failed" && FailOrders.length > 0)) ? (
              <button className="btn-submit" onClick={() => setPage(page + 1)}>
                {isLoading ? (
                  <img src={"./loading.svg"} alt={""} className={"w-loading"} />
                ) : (
                  <>صفحه بعد</>
                )}
              </button>
            ) : (
              <></>
            )}
          </>
        ) : (
          <>هیچ سفارشی ثبت نشده است</>
        )}
      </div>
    </>
  );
}
